<template>
  <div>
      <div class="gangbeng_text">请选择商家</div>
    <div class="gangbeng_banner">
      <div   v-for="(item,index) in storeList" @click="todetail(index)" :class="item.storeselect ? 'shoppingbox_left1' : 'shoppingbox_left'">
        <img class="shopping_img" :src="item.thumb" />
        <div class="shopping_des">{{item.name}}</div>
      </div>
    </div>

    <div v-for="(item,index) in productItem">
      <div class="gangbeng_text">{{item.name}}</div>
      <div class="APPshoppingDetail_quan_List1">
        <div :class="item1.id===id? 'video_detail_chongzhibox1' :'video_detail_chongzhibox'" v-for="(item1,index1) in item.productItem"
          @click="selectnum(index1,index)">
          <div class="video_detail_price">{{item1.name}}</div>
          <div class="video_detail_kind">{{item1.price}}</div>
        </div>
      </div>
    </div>
    <div class="shoppingdetail_bangding" v-if="price!=''" @click="toRecharge()">
      <div class="shoppingdetail_bangding_car">立即支付({{price}}积分)</div>
    </div>
    <div class="shoppingdetail_bangding" v-else>
      <div class="shoppingdetail_bangding_car">立即充值</div>
    </div>
    <div class="shoppingdetail_shuoming" v-if="storeDeatil.detail">
      <div class="shoppingdetail_tip_title">充值说明</div>
      <div class="shoppingdetail_tip">{{storeDeatil.detail}}</div>
    </div>
  </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        amount: "", //用户所有积分数
        listDetail: {}, //上个页面传来的会员详情
        storeDeatil: {}, //接口获取商品详情
        productItem: [], //商品套餐分类列表
        phonenum: "", //手机充值账号
        price: "", //应付金额
        buttonClicked: false, // 防止支付重复点击,默认为false
        packageValue: 0, //套餐标识
        proindex: "", //套餐类型标识
        source_desc: "", //充值说明
        id: "", //套餐详情id
        storeList: [], //接口获取商品列表
        productDetailid: ""
      }
    },
    created() {
      if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
      this.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      //改变商家
      todetail(e){
        let that = this
        console.log("改变")
        let storeList = that.storeList
        storeList.map((item, index) => item.storeselect = index === Number(e))
        that.productDetailid = that.storeList[Number(e)].id
        this.request("getProductDetail", {
              id: this.productDetailid
            })
      },

      changegangbeng(e) {
        let that = this
        let APPshoppingDetail = that.APPshoppingDetail
        APPshoppingDetail.APPshoppingDetailbox.map((item, index) => item.shopSelect = index === Number(e))
      },
      //改变选择的套餐
      selectnum(e, proindex) {
        let that = this
        //获取套餐详情id
        that.id = that.productItem[Number(proindex)].productItem[Number(e)].id
        //that.productItem[Number(proindex)].productItem.map((item1, index1) => item1.packageChecked = index1===Number(e))
        //获取套餐详情价格
        that.price = that.productItem[Number(proindex)].productItem[Number(e)].price
        //获取套餐详情说明
        that.source_desc = that.productItem[Number(proindex)].productItem[Number(e)].source_desc
        //获取套餐类型标识
        that.proindex = Number(proindex)
        //获取套餐详情标识
        that.packageValue = Number(e)
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        // 手机号码格式错误时顶部显示错误提示2秒
        // !/^1[2-9][0-9]{9}$/.test(Number(that.phonenum.toString().substring(0, 11)))
        // if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
        //   this.$swal({
        //     text: '手机号格式错误'
        //   })
        //   return
        // }
        var product = that.storeDeatil
        var productItem = that.productItem[that.proindex].productItem[that.packageValue]
        console.log("productItem", productItem)

        order_param.amount = productItem.price
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_item_id = productItem.id
        order_param.recharge_number = 0
        console.log("that.amount > productItem.price", that.amount > productItem.price)
        // 判断用户是微信支付还是余额支付
        if (parseFloat(that.amount) < parseFloat(productItem.price)) {
          Dialog.confirm({
              title: '提示',
              message: '积分不足，前往充值？',
            })
            .then(() => {
              that.$router.push({
                path: "/account"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          Dialog.confirm({
              title: '提示',
              message: '是否用余额支付?',
            })
            .then(() => {
              order_param.pay_type = 'balance'
              that.request('YeunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        }
      },
      // 调用接口封装
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取个人信息余额
          case 'getUserInfo':
            //获取个人信息余额
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code === 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                console.log('amount1', amount1)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code === 0) {
                console.log("商品列表", res)
                this.storeList = res.data
                this.productDetailid = this.storeList[0].id
                this.storeList[0].storeselect = true
                this.request("getProductDetail", {
                      id: this.productDetailid
                    })
              } else {
                // this.$swal({
                //   text: res.message
                // })
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            //获取商品详情
          case 'getProductDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code === 0) {
                console.log("商品详情", res)
                this.storeDeatil = res.data
                this.productItem = this.storeDeatil.productItem
                // for(let i in this.productItem){
                //   this.productItemDetail = this.productItem[i]
                //   console.log("this.productItemDetail",this.productItemDetail)
                // }
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                // wx.navigateTo({
                //   url: '/pages/order/detail?id=' + res.data.order_no
                // })
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                // wx.showToast({
                //   title: res.data.message || '系统异常',
                //   icon: 'none'
                // })
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
/*  body{
    background-color: #fff;
  } */
  .APPshoppingDetail_quan_List {
    margin: 20px;
  }

  .APPshoppingDetail_quan_List1 {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
    background-color: #fff;
  }

  .APPshoppingDetail_quan_box {
    display: flex;
    margin: 20px 0;
    border: 3px solid #FFFFFF;
  }

  .APPshoppingDetail_quan_box1 {
    display: flex;
    margin: 20px 0;
    border: 3px solid #EE9D27;
  }

  .APPshoppingDetail_box_left {
    width: 40%;
    height: 90px;
  }

  .APPshoppingDetail_box_left_img {
    width: 100%;
    height: 100%;
  }

  .APPshoppingDetail_box_right {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
  }

  .APPshoppingDetail_right_top {
    display: flex;
    width: 170px;
  }

  .APPshoppingDetail_rightl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    margin: 5px;
  }

  .APPshoppingDetail_daijin {}

  .APPshoppingDetail_fenjie {
    border-bottom: 1px dashed #9d9797;
    width: 40px;
    margin-top: 5px;
  }

  .APPshoppingDetail_rmb {}

  .APPshoppingDetail_rightc {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    font-size: 40px;
    width: 70px;
  }

  .APPshoppingDetail_rightr {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: 20px;
    margin-bottom: 10px;
  }

  .APPshoppingDetail_right_bottom {
    border: 1px dashed #9d9797;
    width: 170px;
  }

  .APPshoppingDetail_buybutton {
    margin: 20px 50px;
    height: 50px;
    width: 75%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #58b4c1;
    color: #FFFFFF;
  }

  .gangbeng_banner {
    width: 90%;
    /* height: 160px; */
    padding: 10px 20px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    flex-wrap: wrap;
       background-color: #fff;
    /*  background: -webkit-linear-gradient(bottom, hsl(202, 37%, 90%), hsl(226, 100%, 84%), #3b6bfb) no-repeat;
       */
/*    background-color: #FCDDD8; */
   /* margin: 20px 0; */
  }

  .jinrong {
    /*    margin-left: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .jinrong_img {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-bottom: 20px;
  }

  .jinrong_text {
    color: #000;
    font-size: 22px;
  }

  .video_detail_chongzhibox {
    height: 80px;
    border: 1px solid #dedede;
    padding: 20px 0;
    margin: 10px;
    width: 84px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .video_detail_chongzhibox1 {
    height: 80px;
    border: 1px solid #F0533E;
    padding: 20px 0;
    margin: 10px;
    width: 84px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #F0533E;
  }

  .APPshoppingDetail_gangbeng_box {
    background-image: url(../../../static/gangbeng.png);
    background-size: 100% 100%;
    width: 33%;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #525151;
  }

  .APPshoppingDetail_gangbeng_box1 {
    background-image: url(../../../static/gangbeng1.png);
    background-size: 100% 100%;
    width: 33%;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #f0aa64;
    /*   color: #FFFFFF; */
  }

  .gangbeng_text {
    background-color: #fff;
    padding: 20px;
    font-size: 20px;
  }

  .shoppingDetail_center_text {
    margin: 20px;
    font-size: 20px;
  }

  .shoppingdetail_title {
    margin: 20px 0;
    font-weight: bold;
  }

  .shoppingdetail_bangding {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }

  .shoppingdetail_bangding_car {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 280px;
    height: 50px;
    background-color: #F0533E;
    color: #ffffff;
    border-radius: 25px;
    /*  margin-top: 70px ; */
  }

  .shoppingdetail_shuoming {
    margin: 10px;
    /* background-color: #e6e6e6; */
    border: 1px solid #e6e6e6;
    display: flex;
    flex-direction: column;
    /*    align-items: center;
         justify-content: flex-start; */
    padding: 20px 25px;
    font-size: 15px;
  }

  .shoppingdetail_tip_title {
    margin: 20px 0;
    text-align: center;
  }

  .shoppingdetail_tip {
    display: flex;
    justify-content: flex-start;
  }

  .shoppingdetail_tip1 {
    margin: 5px;
    color: #ff9940;
  }

  /* 商家列表 */
  /*  .shopping_box {

    height: 70px;
    display: flex;

    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #dedede;
    margin-bottom: 20px;
  } */

  .shoppingbox_left {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 82px;
    border: 1px solid #fff;
    /*   justify-content: space-between; */
  }

  .shoppingbox_left1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 82px;
    border: 1px solid #F0533E;
    /*   justify-content: space-between; */
  }

  .shopping_img {
    width: 50px;
    height: 50px;
    /* border-radius: 25px; */
    margin: 10px;
  }

  .shopping_des {}

  .shopping_to {
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/AppshoppingDetail.vue